import * as React from 'react';
import {Helmet} from 'react-helmet';
import {observer, inject} from 'mobx-react';
import Card, {CardHeader, CardBody} from '../../components/Card';
import {FormComponentProps} from 'antd/lib/form/Form';
import {AirbnbListingDetailModelType} from '../../models/AirbnbListingDetailModel';
import {PromoteListingDetailModelType} from '../../models/PromoteListingDetailModel';
import ReactMapGL, {NavigationControl, Marker} from 'react-map-gl';
import {
  Form,
  Input,
  Switch,
  Button,
  message,
  Row,
  Alert,
  Divider,
  Spin,
  Icon,
  Upload,
  Modal
} from 'antd';
import {RouteComponentProps} from 'react-router';
import {getAccessToken} from '../../services/tokenPersistence';

const {TextArea, Search} = Input;

// tslint:disable

const UPLOAD_ENDPOINT =
  (window as any).UPLOAD_ENDPOINT || process.env.REACT_APP_UPLOAD_ENDPOINT;
const MAPBOX_TOKEN =
  (window as any).MAPBOX_TOKEN || process.env.REACT_APP_MAPBOX_TOKEN;

interface CreatePromoteListingProps
  extends FormComponentProps,
    RouteComponentProps<{userId: string}> {
  airbnbListingDetail: AirbnbListingDetailModelType;
  promoteListingDetail: PromoteListingDetailModelType;
}

interface CreatePromoteListingFormState {
  userId: number;
  name?: string;
  address?: string;
  image?: string;
  latitude?: number;
  longitude?: number;
  bedrooms?: number;
  countryCode?: string;

  viewport: any;
  fileList: any;
  previewVisible: boolean;
  previewImage: string;
}

@inject('airbnbListingDetail', 'promoteListingDetail')
@observer
class CreatePromoteListingForm extends React.Component<
  CreatePromoteListingProps,
  CreatePromoteListingFormState
> {
  constructor(props: CreatePromoteListingProps) {
    super(props);
    this.state = {
      userId: this._userId,
      viewport: {
        height: 400,
        width: 600,
        zoom: 12,
        latitude: 37.776021,
        longitude: -122.4171949
      },
      previewVisible: false,
      previewImage: '',
      fileList: [],
      latitude: 37.776021,
      longitude: -122.4171949
    };
  }
  private get _withInjectedProps() {
    return this.props as CreatePromoteListingProps;
  }

  private get _userId() {
    return Number(this._withInjectedProps.match.params.userId);
  }

  public resize = () => {
    this.setState(prevState => ({
      viewport: {
        ...prevState.viewport,
        height: 400,
        width: window.innerWidth - 300
      }
    }));
  };

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
  }
  getUploadEndpoint() {
    return `${UPLOAD_ENDPOINT}/pictures/listing`;
  }

  getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result);
        }
      };
      reader.onerror = error => reject(error);
    });
  }

  handlePreview = async (file: any) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true
    });
  };

  public updateViewport = (viewport: any) => {
    this.setState(prevState => ({
      viewport: {...prevState.viewport, ...viewport}
    }));
  };

  handleChange = ({fileList}: any) => {
    this.setState({fileList});
  };

  handleCancel = () => this.setState({previewVisible: false});

  handleDragEndMarker = (event: any) => {
    const {setFieldsValue} = this.props.form;
    const lngLat = event.lngLat;
    setFieldsValue({
      latitude: lngLat[1],
      longitude: lngLat[0]
    });

    this.setState({
      latitude: lngLat[1],
      longitude: lngLat[0]
    });
  };

  renderUploadButton() {
    const {previewVisible, previewImage, fileList} = this.state;
    const token = getAccessToken();
    const uploadButton = (
      <Button>
        <Icon type="upload" /> Upload
      </Button>
    );
    return (
      <React.Fragment>
        <Upload
          action={this.getUploadEndpoint()}
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          headers={{Authorization: `Bearer ${token}`}}
        >
          {uploadButton}
        </Upload>
        
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{width: '100%'}} src={previewImage} />
        </Modal>
      </React.Fragment>
    );
  }

  public render() {
    const {isLoading} = this._withInjectedProps.airbnbListingDetail;

    return (
      <React.Fragment>
        <Helmet>
          <title>Create Promote Listing</title>
        </Helmet>
        <Card>
          <CardHeader>Create a promote listing </CardHeader>
          <CardBody>
            <Row style={{marginBottom: 20}}>
              <Alert
                type="warning"
                showIcon={true}
                message="Did you register on Airbnb? Please enter listing url and hit
                fetch button."
              />
            </Row>
            <Search
              placeholder="Airbnb listing url"
              enterButton="Fetch"
              onSearch={value => this._handleFetchListingFromAirbnb(value)}
            />
            <Divider>Information</Divider>
            {isLoading ? this._loading() : this._renderForm()}
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
  private _loading() {
    return (
      <div>
        <Spin />
      </div>
    );
  }

  private _renderForm() {
    const {getFieldDecorator} = this.props.form;
    const {viewport} = this.state;
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 4}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 20}
      }
    };
    return (
      <Form layout="vertical" onSubmit={this._handleSubmit}>
        <Form.Item {...formItemLayout} label="Name">
          {getFieldDecorator('name', {
            rules: [
              {
                required: true,
                message: 'Name field is required.'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Internal Name">
          {getFieldDecorator('internalName', {})(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Address">
          {getFieldDecorator('address', {
            rules: [
              {
                required: true,
                message: 'Address field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Latitude">
          {getFieldDecorator('latitude', {
            rules: [
              {
                required: true,
                message: 'Latitude field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Longitude">
          {getFieldDecorator('longitude', {
            rules: [
              {
                required: true,
                message: 'Longitude field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Bedrooms">
          {getFieldDecorator('bedrooms', {
            rules: [
              {
                required: true,
                message: 'Bedrooms field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Country Code">
          {getFieldDecorator('countryCode', {
            rules: [
              {
                required: true,
                message: 'Country code field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Requirements">
          {getFieldDecorator('requirements', {
            rules: [
              {
                required: true,
                message: 'Requirements field is required'
              }
            ]
          })(<TextArea rows={8} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Commission">
          {getFieldDecorator('commission', {
            rules: [
              {
                required: true,
                message: 'Commission field is required'
              }
            ]
          })(<TextArea rows={4} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Images">
          {getFieldDecorator('images', {})(this.renderUploadButton())}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Publish">
          {getFieldDecorator('state', {
            initialValue: false,
            rules: [
              {
                required: true,
                message: 'Publish field is required'
              }
            ]
          })(<Switch />)}
        </Form.Item>
        <ReactMapGL
          {...viewport}
          mapboxApiAccessToken={MAPBOX_TOKEN}
          onViewportChange={(v: any) => this.updateViewport(v)}
        >
          <div style={{position: 'absolute', right: 30, bottom: 30}}>
            <NavigationControl onViewportChange={this.updateViewport} />
          </div>
          <Marker
            draggable={true}
            latitude={this.state.latitude ? this.state.latitude : 37.776021}
            longitude={
              this.state.longitude ? this.state.longitude : -122.4171949
            }
            onDragEnd={this.handleDragEndMarker}
          >
            <Icon
              type="environment"
              style={{color: 'red', fontSize: '30px'}}
            />
          </Marker>
        </ReactMapGL>
        <Form.Item {...formItemLayout}>
          <Button type="primary" htmlType="submit">
            Create
          </Button>
        </Form.Item>
      </Form>
    );
  }

  private extractListingId(link: string) {
    const regex = /\/rooms\/(\d+)/g;
    const arr = regex.exec(link);
    if (!arr) {
      return null;
    }
    try {
      return arr[1];
    } catch {
      return null;
    }
  }

  private _buildListImages(photos: any) {
    if (!photos) {
      return [];
    }
    return photos.reduce((results: any, item: any) => {
      results.push({
        uid: String(item.id),
        name: 'image.jpg',
        status: 'done',
        url: item.picture
      });

      return results;
    }, []);
  }

  private async _handleFetchListingFromAirbnb(link: string) {
    link = link.trim();
    const listingId = this.extractListingId(link);
    if (!listingId) {
      message.error('Airbnb listing url is invalid');
      return;
    }
    await this._withInjectedProps.airbnbListingDetail.getListing(
      Number(listingId)
    );
    const {listing} = this._withInjectedProps.airbnbListingDetail;

    if (listing) {
      this.props.form.setFieldsValue({
        name: listing.name,
        address: listing.address,
        latitude: listing.lat,
        longitude: listing.lng,
        countryCode: listing.countryCode,
        bedrooms: listing.bedrooms
      });

      this.setState({
        latitude: listing.lat,
        longitude: listing.lng,
        fileList: this._buildListImages(listing.photos),
        viewport: {
          ...this.state.viewport,
          latitude: listing.lat,
          longitude: listing.lng
        }
      });
    }
  }

  private callback(err: boolean, msg: string) {
    if (err) {
      message.error(msg);
    } else {
      message.info(msg);
    }
  }

  private _getListingImages() {
    const {fileList} = this.state;
    if (!fileList) {
      return [];
    }

    return fileList.reduce((results: any, item: any) => {
      if (item.url) {
        results.push({
          url: item.url,
          caption: ''
        });
      } else if (item.response && item.response.url) {
        results.push({
          url: item.response.url,
          caption: ''
        });
      }
      return results;
    }, []);
  }

  private _handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error('Something went wrong');
        return;
      }
      const data = values;
      data.state = data.state ? 'ACTIVATED' : 'DEACTIVATED';
      data.userId = this._userId;
      data.images = this._getListingImages();
      this._withInjectedProps.promoteListingDetail.createListing(
        data,
        this.callback
      );
      this.props.history.push(`/users/${this._userId}`);
    });
  };
}

const CreatePromoteListing = Form.create()(CreatePromoteListingForm);
export default CreatePromoteListing;



// WEBPACK FOOTER //
// ./src/pages/CreatePromoteListing/CreatePromoteListing.tsx